import { Box, Divider, Typography } from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import { TripleStateToggler } from "nemuru-components";
import React, { Fragment } from "react";
import { Controller } from "react-hook-form";
import { checkIfOptinHasLinksAndReturnDescription } from "../../../utils/optInsHelpers";
import Text from "./Text";
import { getCustomConfigByAppTheme } from "../../../config/config";
import { ErrorMessage } from "./ErrorMessage";
import { useTranslation } from "../../../utils/hooks/useTranslation";

export default function OptinsManager({
  optInsState,
  handleChange,
  errors,
  control,
}) {
  const { spacing } = useTheme();
  const { getTextIdTranslation } = useTranslation();

  const inputNameValidation = (inputName) => {
    return {
      error: Object.prototype.hasOwnProperty.call(errors, inputName),
      message:
        Object.prototype.hasOwnProperty.call(errors, inputName) &&
        errors[inputName].message,
    };
  };

  return (
    <>
      {optInsState?.length > 0 &&
        optInsState.map((optin, index) => {
          return (
            <Fragment key={index}>
              <Box
                container={"true"}
                className={"mb-1"}
                style={{
                  display: "inline-flex",
                  width: "100%",
                  marginTop: spacing(1),
                  alignItems: "flex-start",
                }}
              >
                <Controller
                  defaultValue={optin.checked}
                  name={optin.name}
                  control={control}
                  rules={{
                    required: {
                      value: optin.required,
                      message: <Text tId={"PLEASE_ACCEPT_CONDITIONS"} />,
                    },
                    validate: {
                      validate: (value) => value !== null,
                    },
                  }}
                  render={() => (
                    <>
                      <TripleStateToggler
                        disabled={
                          !getCustomConfigByAppTheme().allowTrueOptInsGoFalse &&
                          optin.checked === true
                        }
                        inputProps={{
                          "aria-label": `Checkbox for optin ${getTextIdTranslation(
                            optin.name
                          )}`,
                        }}
                        name={optin.name}
                        key={optin.condition_id}
                        handleChange={handleChange}
                        value={optin.checked}
                      />
                    </>
                  )}
                />
                <Typography
                  variant="caption"
                  color="textPrimary"
                  style={{
                    lineHeight: 1.5,
                    fontSize: 11,
                    wordWrap: "anywhere",
                  }}
                >
                  {checkIfOptinHasLinksAndReturnDescription(optin)}
                  {inputNameValidation(optin.name).error && (
                    <ErrorMessage
                      errorMsg={inputNameValidation(optin.name).message}
                    />
                  )}
                </Typography>
              </Box>
              {index < optInsState?.length - 1 && <Divider light />}
            </Fragment>
          );
        })}
    </>
  );
}
